import { render, staticRenderFns } from "./HeatingPie.vue?vue&type=template&id=2a632a63&scoped=true"
import script from "./HeatingPie.vue?vue&type=script&lang=js"
export * from "./HeatingPie.vue?vue&type=script&lang=js"
import style0 from "./HeatingPie.vue?vue&type=style&index=0&id=2a632a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a632a63",
  null
  
)

export default component.exports